export const createGetCarouselRequest = (id) => {
  return {
    url: "/carousels/" + id,
    method: "GET",
  };
};

// On save, image/logo elements that carry a media_id must NOT also
// carry a non-empty URL — the server rejects "both set" with 422. We
// keep the URL on the local state for in-editor preview, but strip it
// here right before send. The next GET re-derives a fresh signed URL
// from the media_id.
//
// "image" and "logo" both participate in the contract. Slide image
// elements use a flat string value; common_settings image and logo
// elements use { image, ... } so we clear value.image while preserving
// siblings like scale/align.
const MEDIA_ELEMENT_TYPES = new Set(["image", "logo"]);
const PREVIEW_SOURCE_KEY = "_preview_source_url";

const stripValueIfMediaId = (el) => {
  const { [PREVIEW_SOURCE_KEY]: previewSource, ...element } = el;

  // Background media is not part of the API's media resolver yet. Keep its
  // existing remote value for persistence, while removing the data URL used
  // only by the editor/export path.
  if (element.type === "background" && previewSource) {
    return {
      ...element,
      value: { ...element.value, image: previewSource },
    };
  }

  if (!MEDIA_ELEMENT_TYPES.has(element.type) || !element.media_id) {
    if (!previewSource) return element;
    if (element.value && typeof element.value === "object") {
      return { ...element, value: { ...element.value, image: previewSource } };
    }
    return { ...element, value: previewSource };
  }

  if (element.value && typeof element.value === "object") {
    return { ...element, value: { ...element.value, image: "" } };
  }
  return { ...element, value: "" };
};

const stripUrlsWhereMediaIdPresent = (carousel) => {
  const slides = (carousel.slides || []).map((slide) => ({
    ...slide,
    elements: (slide.elements || []).map(stripValueIfMediaId),
  }));
  const cs = carousel.common_settings || {};
  const common_settings = {
    ...cs,
    elements: (cs.elements || []).map(stripValueIfMediaId),
  };
  return { slides, common_settings };
};

export const createSaveCarouselRequest = (
  slides,
  common_settings,
  content,
  template_id
) => {
  const sanitized = stripUrlsWhereMediaIdPresent({ slides, common_settings });
  return {
    url: "/carousels",
    method: "POST",
    data: {
      slides: sanitized.slides,
      common_settings: sanitized.common_settings,
      content,
      template_id,
    },
  };
};

export const createUpdateCarouselRequest = (
  id,
  slides,
  common_settings,
  content
) => {
  const sanitized = stripUrlsWhereMediaIdPresent({ slides, common_settings });
  return {
    url: "/carousels/" + id,
    method: "PUT",
    data: {
      slides: sanitized.slides,
      common_settings: sanitized.common_settings,
      content,
    },
  };
};

export const createDeleteCarouselRequest = (id) => {
  return {
    url: "/carousels/" + id,
    method: "DELETE",
  };
};

export const createGetCarouselsRequest = (page, per_page) => {
  return {
    url: "/carousels",
    method: "GET",
    params: {
      page,
      per_page,
    },
  };
};

export const createGetCarouselsCountRequest = () => {
  return {
    url: "/carousels/count",
    method: "GET",
  };
};
